import {registerReactPartial} from '@github-ui/react-core/register-partial'
import {CopilotCodingAgentStatus} from './CopilotCodingAgentStatus'

registerReactPartial('copilot-coding-agent-status', {
  Component: CopilotCodingAgentStatus,
})
